

const LegendLayerKey = function ({ label, imageData, index }) {
  return (
    <li className="key">
      <div className="key-indicator">
        <img src={`data:image/png;base64,${imageData}`} alt={`${label} icon`} />
      </div>
      <span className="key-name">{label}</span>
    </li>
  )
}

export default LegendLayerKey